<template>
  <section class="hero">
    <div class="hero-overlay">
      <div class="hero-content">
        <h2 v-for="value in info?.home_title" :key="value">
          {{ value }}
        </h2>
        <p v-for="value in info?.home_subtitle" :key="value">
          {{ value }}
        </p>
        <div class="hero-buttons">
          <!-- <button class="btn-primary">在线预约</button>
          <button class="btn-secondary">科室导航</button> -->
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
interface titleType {
  home_title?: string[];
  home_subtitle?: string[];
}

interface SectionProps {
  info?: titleType;
}
withDefaults(defineProps<SectionProps>(), {});
</script>

<style scoped>
.hero {
  height: 500px;
  background-image: url("/Environment/全院/0.png");
  background-size: cover;
  background-position: center;
  position: relative;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(26, 95, 180, 0.8),
    rgba(26, 95, 180, 0.4)
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content {
  text-align: center;
  color: white;
  max-width: 1200px;
  padding: 0 20px;
}

.hero-content h2 {
  font-size: 3rem;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.3;
}

.hero-content p {
  font-size: 24px;
  margin-bottom: 30px;
  color: #f9cc9d;
  line-height: 1.5;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary {
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 120px;
}

.btn-primary {
  background-color: #fff;
  color: #1a5fb4;
}

.btn-primary:hover {
  background-color: #f0f0f0;
  transform: translateY(-2px);
}

.btn-secondary {
  background-color: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* 平板端适配 */
@media (max-width: 1024px) {
  .hero {
    height: 400px;
  }
  
  .hero-content h2 {
    font-size: 2.5rem;
  }
  
  .hero-content p {
    font-size: 20px;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .hero {
    height: 350px;
  }
  
  .hero-content h2 {
    font-size: 2rem;
    margin-bottom: 15px;
  }
  
  .hero-content p {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .hero-buttons {
    gap: 15px;
  }
  
  .btn-primary,
  .btn-secondary {
    padding: 10px 25px;
    font-size: 0.95rem;
    min-width: 110px;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .hero {
    height: 300px;
  }
  
  .hero-content {
    padding: 0 15px;
  }
  
  .hero-content h2 {
    font-size: 1.6rem;
    margin-bottom: 12px;
  }
  
  .hero-content p {
    font-size: 16px;
    margin-bottom: 15px;
  }
  
  .hero-buttons {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
  
  .btn-primary,
  .btn-secondary {
    width: 100%;
    max-width: 250px;
    padding: 12px 20px;
  }
}
</style>
